(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue"], factory);
	else if(typeof exports === 'object')
		exports["VueTreeselect"] = factory(require("Vue"));
	else
		root["VueTreeselect"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__34__) {
return 